module.exports = __webpack_public_path__ + "static/nick-signature-52bbb7bd9a7ece3fe1fc374e77c6f302.jpg";